export interface IRavenObject<T = any> {
    [property: string]: T;
}
